export default "__VITE_ASSET__CsPrmr61__"